import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import UserDashboard from "@/pages/UserDashboard";
import DealerDashboard from "@/pages/DealerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

/**
 * /dashboard resolves to the dashboard matching the effective user's role.
 * Because View-As starts a real impersonation against a sandbox account,
 * `user.role` is the impersonated role and this dispatches correctly without
 * any role-override flag.
 */
export default function RoleAwareDashboard() {
  const { user } = useAuth();
  if (user?.role === "dealer") return <DealerDashboard />;
  if (user?.role === "admin") return <AdminDashboard />;
  return <UserDashboard />;
}
